export default "__VITE_ASSET__CbAODI_5__"